import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PAIN_CARDS } from '../../data/content';
export function Pain() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-144" data-mp="2dtwf3fmm9af1">
      <div className="mx-auto max-w-5xl" data-id="element-145" data-mp="2hwknjm7f4fbh">
        <Reveal className="text-center" data-id="element-146" data-mp="2hxm0xxbwpdwd">
          <SectionBadge data-id="element-147" data-mp="2hu7uoe04gkjn">Te suena</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-148" data-mp="2mwf9dbcc6epo">
            Si sos profesora de danza clásica, esto <span className="u-lime" data-id="element-149" data-mp="2rsnpaqycybxw">seguramente te pasa</span>
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-150" data-mp="2wnjpwfhnu7mm">
          {PAIN_CARDS.map((card, index) => <Reveal key={card.title} delay={index % 3 * 80} as="article" data-id="element-151" data-mp="35m58ubr1nonx" data-mpi={index}>
              <div className="h-full rounded-2xl border border-white/10 bg-ink/90 p-5" data-id="element-152" data-mp="35k27wwocsb4f">
                <AlertCircleIcon className="h-5 w-5 text-lime" aria-hidden="true" data-id="element-153" data-mp="3alhqmi3265jn" />
                <h3 className="mt-3.5 text-base font-bold leading-snug text-snow" data-id="element-154" data-mp="20pwk2ydr9g9j">{card.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-155" data-mp="1wl6nf7b9vxnk">{card.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}